/**
 *
 * Navigation
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */

import React, { useContext } from 'react';

import Authenticated from './Authenticated';
import UnAuthenticated from './UnAuthenticated';
import AuthenticationContext from '../contexts/AuthenticationContext';
import SplashScreen from './SplashScreen';
import CloudFunctionClientProvider from '../contextProviders/SplashScreenProviders/UserAndAccountProviders/CloudFunctionClientProvider';
import usePersistedTheme from '../theme/usePersistedTheme';
import WallboardPlayer from '../screens/WallboardPlayer';

const Navigation = () => {
  usePersistedTheme();
  const { authenticated, isWallboardTv, wallBoardAccountId } = useContext(
    AuthenticationContext,
  );

  // A screenshot wallboard TV has no data access, so it never mounts the
  // SplashScreen's data providers: it only plays its screenshots.
  if (authenticated && isWallboardTv) {
    return (
      <CloudFunctionClientProvider accountId={wallBoardAccountId}>
        <WallboardPlayer />
      </CloudFunctionClientProvider>
    );
  }

  if (!authenticated) {
    return (
      <CloudFunctionClientProvider>
        <UnAuthenticated />
      </CloudFunctionClientProvider>
    );
  }

  return (
    <SplashScreen>
      <Authenticated />
    </SplashScreen>
  );
};

export default Navigation;
